/**
 * @file       Auth routes, used by the whole auth module.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import Base from "@/modules/auth/base.vue";
import LogingOptions from "@/modules/auth/components/loginOptions.vue";
import LogingStudents from "@/modules/auth/components/loginStudents.vue";
import LogingPseudo from "@/modules/auth/components/loginPseudo.vue";
import LogingCreate from "@/modules/auth/components/loginCreate.vue";
import Loging from "@/modules/auth/components/login.vue";
import Forgot from "@/modules/auth/components/forgot.vue";
import SetPassword from "@/modules/auth/components/setPassword.vue";
import Conditions from "@/modules/auth/components/conditions.vue";


/**
 * Auth routes.
 *
 * @type  {array}
 */
const routes = [
  {
    path: "/auth",
    component: Base,
    children: [
      {
        path: "login/options",
        component: LogingOptions,
        name: "auth.login.options",
        meta: { layout: "auth" }
      },
      {
        path: "login",
        component: Loging,
        name: "auth.login",
        meta: { layout: "auth" }
      },
      {
        path: "login/participants",
        component: LogingStudents,
        name: "auth.login.students",
        meta: { layout: "auth" }
      },
      {
        path: "login/pseudo",
        component: LogingPseudo,
        name: "auth.login.pseudo",
        meta: { layout: "auth" }
      },
      {
        path: "login/create",
        component: LogingCreate,
        name: "auth.login.create",
        meta: { layout: "auth" }
      },
      {
        path: "forgot",
        component: Forgot,
        name: "auth.forgot",
        meta: { layout: "auth" }
      },
      {
        path: "conditions",
        component: Conditions,
        name: "auth.conditions",
        meta: { layout: "auth" }
      }
    ]
  },
  {
    path: "/invite/:hash",
    component: SetPassword,
    name: "invite.setPassword"
  }
];

export default routes;
